import React, {PureComponent} from 'react';
import styled from "styled-components";
import Sizes from "../Assets/Sizes";
import {LinearProgress} from 'rmwc/LinearProgress';

const InternalCoreWrapper = styled.div.attrs({
    className: 'page__core-wrapper',
})`
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background: ${p => !p.invertedColors ? p.theme.colors.surfaceBottom : p.theme.colors.modalBackground};
    direction: ${p => p.ltr ? 'ltr' : 'rtl'};
    padding-top: ${props => props.padding ? Sizes.toolbarHeight : 0};
    overflow: hidden;
`;

const LoaderWrapper = styled.div`
    opacity: ${props => props.loading ? 1 : 0};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    transition: opacity 0.3s ease-in-out;
    --mdc-theme-primary: #4D4D4D;
    z-index: 100;
`;

const Mask = styled.div`
    background-color: rgba(0, 0, 0, ${props => props.loading ? '0.3' : 0});
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 0.3s ease-in-out;
    z-index: ${props => props.loading ? 1000 : -5};
`;

const TextCenter = styled.div`
    text-align: center;

    * {
        text-align: center;
    }


`;

const CoreWrapper = (props) => (
    <InternalCoreWrapper {...props}>
        {props.bgImageEl}
        <Mask loading={props.loading}/>
        <LoaderWrapper loading={props.loading}>
            {props.loading && <LinearProgress determinate={false}/>}
        </LoaderWrapper>
        {props.children}
    </InternalCoreWrapper>
);

const RelativeWrapper = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
    background: ${p => !p.invertedColors ? p.theme.colors.surfaceBottom : p.theme.colors.modalBackground};
    direction: ${p => p.ltr ? 'ltr' : 'rtl'};
    padding-top: ${props => props.padding ? Sizes.toolbarHeight : 0};
    padding-bottom: ${props => props.bottomPadding ? '50px' : '30px'};
    overflow: hidden;
`;

const SelectViewWrapper = (props) => (
    <RelativeWrapper {...props} className="page__relative-container">
        <Mask loading={props.loading}/>
        <LoaderWrapper loading={props.loading}>
            {props.loading && <LinearProgress determinate={false}/>}
        </LoaderWrapper>
        {props.children}
    </RelativeWrapper>
);


const TopWrapper = styled.div.attrs({
    className: 'page__top-wrapper',
})`
    position: relative;
    display: flex;
    justify-content: ${props => props.justify || 'space-around'};
    flex-direction: column;
    align-items: ${props => props.align || 'center'};
    height: ${props => props.constantHeight ? 'calc(100% - 85px)' : '100%'};
    padding-top: ${props => props.padding ? Sizes.defaultPadding : 0};
    padding-bottom: ${props => props.padding ? Sizes.defaultPadding : 0};

`;


const BottomWrapper = styled.div.attrs({
    className: 'page__bottom-wrapper',
})`
    width: 100%;
    min-height: ${props => props.empty ? Sizes.footerPoweredByMinHeight : Sizes.footerButtonMinHeight};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    z-index: 1;
    position: relative;


    .slide-from-bottom-enter {
        opacity: 0;
        max-height: 0;
        overflow: hidden;
        transform: translateY(150px);
    }

    .slide-from-bottom-enter-active {
        opacity: 1;
        overflow: hidden;
        transform: translateY(0);
        max-height: 150px;
        transition: all 500ms ease-in;
    }
`;


const FooterPoweredWrapper = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    direction: ltr;
    font-size: ${Sizes.smallText};
    color: ${p => p.theme.colors.primaryText};
    text-decoration: none;
    cursor: pointer;

    img {
        height: ${Sizes.footerImgSize};
        margin-left: ${Sizes.textMargin};
    }
`;

class ScrollableContentWrapper extends PureComponent {
    render() {
        return (<StyledScrollableContentWrapper preventPaddingBottom={this.props.preventPaddingBottom}
                                           className="items-picker__wrapper">
            {this.props.children}
        </StyledScrollableContentWrapper>);
    }
}


const StyledScrollableContentWrapper = styled.div`
    position: relative;
    overflow: auto;
    width: 100%;

    > div {
        height: 100%;
        overflow-y: scroll;
        padding-left: 15px;
        padding-right: 15px;
        -webkit-overflow-scrolling: touch;
    }
`;

const AbsoluteCenter = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
`;

/*Used for preloading images.*/
const InvisibleImage = styled.img`
    visibility: hidden;
    height: 0;
    width: 0;
    position: absolute;
    right: 0;
    bottom: 0;
`;

const Bold = styled.span`
    font-weight: 500;
`;

const PreventEvents = styled.span`
    &, * {
        pointer-events: none;
    }
`;

export {
    CoreWrapper,
    SelectViewWrapper,
    TopWrapper,
    BottomWrapper,
    FooterPoweredWrapper,
    ScrollableContentWrapper,
    AbsoluteCenter,
    InvisibleImage,
    Bold,
    PreventEvents,
    TextCenter,
    LoaderWrapper
}
